import { connect } from "react-redux";

import { CandyDispatch, CandyThunkAction } from "../../../Store/CandyReduxTypes";
import { FullFormState } from "../../../Store/FullFormState";
import { reloadForm } from "../../../../ActionCreators/FufUploadActionCreator";
import { waitPollingTask } from "../../../../../../../Common/CandyApiClient/Types/PollingTasks/PollingTaskWaiter";

import { ZeroReporting } from "./ZeroReporting";

export function customNormalizeAction(normalizeId: string, abortSignal?: AbortSignal): CandyThunkAction<Promise<void>> {
    return async (_, __, form) => {
        await form.changeSet.send();
        await form.candyApiDraftClient.startCustomNormalizationTask([], normalizeId);
        await waitPollingTask(() => form.candyApiDraftClient.getCustomNormalizationTask(), abortSignal);
    };
}

export function validateChildrenAndFocus(validationPath: string): CandyThunkAction<boolean> {
    return (_, __, form: IForm) => form.focusFirstInvalidControlByPath(validationPath);
}

const mapStateToProps = (state: FullFormState) => ({
    callInitZeroReport: state.settings.callInitZeroReport,
});

const mapDispatchToProps = (dispatch: CandyDispatch) => ({
    customNormalize: (normalizeId: string, abortSignal?: AbortSignal): Promise<void> =>
        dispatch(customNormalizeAction(normalizeId, abortSignal)),
    reloadForm: (): void => reloadForm(),
    localValidationBeforeSend: async (validationPath: string) => dispatch(validateChildrenAndFocus(validationPath)),
});

export const ZeroReportingContainer = connect(mapStateToProps, mapDispatchToProps)(ZeroReporting);
